import AddDamagedOtherLegalForm from '@/modules/adjusterReportModules/IncidentParticipants/components/addDamagedPerson/forms/AddDamagedOtherLegalForm';
import AddDamagedOtherRealForm from '@/modules/adjusterReportModules/IncidentParticipants/components/addDamagedPerson/forms/AddDamagedOtherRealForm';
import AddDamagedVehicleLegalForm from '@/modules/adjusterReportModules/IncidentParticipants/components/addDamagedPerson/forms/AddDamagedVehicleLegalForm';
import AddDamagedVehicleRealForm from '@/modules/adjusterReportModules/IncidentParticipants/components/addDamagedPerson/forms/AddDamagedVehicleRealForm';
import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

const AddDamagedFormRender = () => {
  const methods = useFormContext();
  const formData = useWatch({ control: methods.control });

  const renderForm = useMemo(() => {
    const ownerType = formData.owner_type;
    const damage_type = formData.damaged_type;

    if (damage_type === 'VEHICLE') {
      switch (ownerType) {
        case 'real':
          return <AddDamagedVehicleRealForm />;

        case 'legal':
          return <AddDamagedVehicleLegalForm />;
      }
    }
    if (damage_type === 'OTHER') {
      switch (ownerType) {
        case 'real':
          return <AddDamagedOtherRealForm />;

        case 'legal':
          return <AddDamagedOtherLegalForm />;
      }
    }
  }, [formData.owner_type, formData.damaged_type]);
  return renderForm;
};

export default AddDamagedFormRender;
